export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      about: 'Nosotros',
      services: 'Servicios',
      properties: 'Propiedades',
      sell: 'Vende tu Casa',
      jobs: 'Empleo',
      contact: 'Contacto',
      langLabel: 'EN',
      cta: 'Contáctanos',
    },
    hero: {
      badge: 'Empresa Inmobiliaria Certificada · Tuxtla Gutiérrez, Chiapas',
      line1: 'PATRIMONIO QUE',
      line2: 'INSPIRA FUTURO',
      subtitle: 'Desarrollamos, comercializamos y gestionamos proyectos inmobiliarios de alto valor con legalidad, transparencia y eficiencia absoluta.',
      cta1: 'Agendar Consulta Gratuita',
      cta2: 'Explorar Servicios',
      stat1: { value: '5', label: 'Socios Expertos' },
      stat2: { value: '10+', label: 'Años de Experiencia' },
      stat3: { value: '100%', label: 'Respaldo Legal' },
    },
    about: {
      badge: 'NUESTRA HISTORIA',
      title: 'Respaldo Experto.',
      titleAccent: 'Resultados Reales.',
      body: 'GRUPO NOVEGA BIENES RAICES nació de la visión compartida de cinco socios con experiencia combinada en el sector inmobiliario de Chiapas. Somos una empresa innovadora, respaldada por un equipo de abogados fiscalistas expertos en el medio inmobiliario, comprometidos con la legalidad y la excelencia en cada transacción.',
      missionLabel: 'NUESTRA MISIÓN',
      mission: 'Brindar soluciones integrales mediante el desarrollo, comercialización y gestión de proyectos habitacionales y comerciales, con legalidad, transparencia y eficiencia, para proteger y maximizar el patrimonio de nuestros clientes.',
      legalBacking: 'Respaldado por un equipo de abogados fiscalistas expertos en el medio inmobiliario',
      values: [
        'Integridad y Transparencia',
        'Profesionalismo',
        'Responsabilidad Legal',
        'Enfoque al Cliente',
        'Innovación Continua',
        'Desarrollo Sostenible',
      ],
    },
    trayectoria: {
      badge: 'TRAYECTORIA PROFESIONAL',
      title: 'Asesores',
      titleAccent: 'Certificados',
      subtitle: 'Nuestro equipo cuenta con acreditaciones y reconocimientos que garantizan la más alta calidad en cada asesoría inmobiliaria.',
      advisors: [
        {
          name: 'Asesor Inmobiliario Senior',
          role: 'Especialista en Bienes Raíces',
          certs: ['Certificado AMPI', 'Valuador Certificado', 'Crédito Hipotecario'],
        },
        {
          name: 'Abogado Fiscalista',
          role: 'Asesor Legal Inmobiliario',
          certs: ['Cédula Profesional', 'Derecho Fiscal', 'Derecho Inmobiliario'],
        },
        {
          name: 'Gestor de Desarrollos',
          role: 'Especialista en Proyectos',
          certs: ['Certificado PMI', 'Análisis de Mercado', 'Valuación Comercial'],
        },
        {
          name: 'Agente Comercial',
          role: 'Comercialización Integral',
          certs: ['Negociación Avanzada', 'Marketing Inmobiliario', 'CRM Especializado'],
        },
      ],
      cta: 'Conocer Nuestro Equipo',
      uploadCta: '¿Eres asesor certificado? Únete al equipo',
    },
    services: {
      badge: 'NUESTROS SERVICIOS',
      title: 'Proteger Tu',
      titleAccent: 'Patrimonio',
      subtitle: 'Confíanos la comercialización integral de tu inmueble. Nos encargamos de todo: valuación, marketing, negociación y cierre legal.',
      priceHeader: 'Precios de Referencia',
      businessModel: 'Tú nos contactas — nosotros nos encargamos de la comercialización integral de tu propiedad.',
      items: [
        {
          id: 'intermediacion',
          icon: 'Home',
          label: 'INTERMEDIACIÓN',
          title: 'Intermediación Inmobiliaria',
          description: 'Confíanos tu propiedad y nuestro equipo gestiona toda la comercialización: valuación, publicidad, atención a compradores y cierre con respaldo legal completo.',
          pricing: [
            { name: 'Gestión de ventas', price: 'Comisión 5%–7%', note: 'sobre el valor de venta' },
            { name: 'Gestión de compras', price: 'Comisión 3%–5%', note: 'sobre el valor de compra' },
            { name: 'Gestión de rentas', price: '1 mes de renta', note: 'por colocación exitosa' },
          ],
          cta: 'Solicitar Gestión',
        },
        {
          id: 'asesoria',
          icon: 'FileText',
          label: 'ASESORÍA',
          title: 'Asesoría Especializada',
          description: 'Contamos con especialistas en derecho inmobiliario, fiscalidad y gestión de créditos hipotecarios para maximizar su inversión y reducir riesgos.',
          pricing: [
            { name: 'Asesoría legal inmobiliaria', price: 'Desde $1,500 MXN', note: 'por consulta' },
            { name: 'Asesoría fiscal inmobiliaria', price: 'Desde $2,000 MXN', note: 'por consulta' },
            { name: 'Gestión de crédito hipotecario', price: 'Sin costo / $3,000 MXN', note: 'por gestión' },
          ],
          cta: 'Agendar Consulta',
        },
        {
          id: 'gestion',
          icon: 'TrendingUp',
          label: 'GESTIÓN PATRIMONIAL',
          title: 'Gestión Patrimonial',
          description: 'Analizamos, evaluamos y potenciamos su patrimonio inmobiliario con estudios de mercado precisos, valoraciones y estrategias de marketing efectivas.',
          pricing: [
            { name: 'Evaluación y análisis del inmueble', price: 'Desde $2,500 MXN', note: '' },
            { name: 'Valoración comercial de mercado', price: 'Desde $3,500 MXN', note: '' },
            { name: 'Marketing y publicidad inmobiliaria', price: 'Desde $2,000 MXN', note: 'por campaña' },
          ],
          cta: 'Solicitar Valuación',
        },
      ],
    },
    properties: {
      badge: 'PROPIEDADES DESTACADAS',
      title: 'Ventas y',
      titleAccent: 'Rentas',
      subtitle: 'Selección de inmuebles premium en Tuxtla Gutiérrez y zonas de alto valor en Chiapas.',
      contactCta: 'Solicitar Información',
      detailsCta: 'Ver Detalles',
      viewAll: 'Ver Todas las Propiedades',
      beds: 'Hab',
      baths: 'Baños',
      sqm: 'm²',
      filterAll: 'Todos',
      filterVenta: 'Ventas',
      filterRenta: 'Rentas',
      items: [
        {
          id: 1,
          category: 'venta',
          type: 'Residencial',
          title: 'Casa Residencial Premium',
          location: 'Fracc. Terán, Tuxtla Gutiérrez',
          price: '$4,500,000',
          currency: 'MXN',
          beds: 4,
          baths: 3,
          sqm: 320,
          badge: 'DESTACADO',
          image: 'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
          id: 2,
          category: 'renta',
          type: 'Departamento',
          title: 'Departamento Ejecutivo',
          location: 'Zona Centro, Tuxtla Gutiérrez',
          price: '$12,000',
          currency: 'MXN/mes',
          beds: 2,
          baths: 2,
          sqm: 95,
          badge: 'EN RENTA',
          image: 'https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
          id: 3,
          category: 'venta',
          type: 'Comercial',
          title: 'Local Comercial Estratégico',
          location: 'Blvd. Belisario Domínguez',
          price: '$850,000',
          currency: 'MXN',
          beds: null,
          baths: null,
          sqm: 120,
          badge: 'EN VENTA',
          image: 'https://images.pexels.com/photos/260931/pexels-photo-260931.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
      ],
    },
    desarrollos: {
      badge: 'PROYECTOS DE DESARROLLO',
      title: 'Desarrollos',
      titleAccent: 'Inmobiliarios',
      subtitle: 'Proyectos de desarrollo residencial y comercial con los más altos estándares de calidad en Chiapas.',
      statusLabel: 'Estado',
      detailsCta: 'Ver Detalles',
      items: [
        {
          id: 1,
          title: 'Residencial Las Cumbres',
          location: 'Berriozábal, Chiapas',
          status: 'EN PREVENTA',
          statusColor: 'gold',
          description: 'Conjunto residencial de 40 unidades con amenidades de primer nivel, áreas verdes y seguridad 24/7.',
          units: '40 Unidades',
          delivery: 'Q4 2026',
          type: 'Residencial',
          image: 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
          id: 2,
          title: 'Plaza Comercial El Jobo',
          location: 'El Jobo, Tuxtla Gutiérrez',
          status: 'EN CONSTRUCCIÓN',
          statusColor: 'blue',
          description: 'Desarrollo comercial con 15 locales estratégicamente ubicados en una de las zonas de mayor crecimiento.',
          units: '15 Locales',
          delivery: 'Q2 2027',
          type: 'Comercial',
          image: 'https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
          id: 3,
          title: 'Villas Copoya',
          location: 'Copoya, Chiapas',
          status: 'PRÓXIMAMENTE',
          statusColor: 'muted',
          description: 'Exclusivo fraccionamiento horizontal con 25 villas de lujo en el corazón de Copoya.',
          units: '25 Villas',
          delivery: '2027',
          type: 'Residencial Premium',
          image: 'https://images.pexels.com/photos/259588/pexels-photo-259588.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
      ],
      cta: 'Solicitar Información del Desarrollo',
    },
    vende: {
      badge: 'VENDE TU PROPIEDAD',
      title: '¿Quieres Vender',
      titleAccent: 'tu Casa?',
      subtitle: 'Cuéntanos sobre tu propiedad y nuestro equipo te contactará para ofrecerte una valuación y estrategia de venta sin compromiso.',
      formName: 'Nombre completo',
      formEmail: 'Correo electrónico',
      formPhone: 'Teléfono',
      formAddress: 'Ubicación de la propiedad',
      formType: 'Tipo de propiedad',
      formTypeOptions: ['Casa', 'Departamento', 'Terreno', 'Local Comercial', 'Otro'],
      formMessage: 'Cuéntanos más sobre tu propiedad (tamaño, estado, motivo de venta)...',
      formSubmit: 'Enviar Información',
      formSending: 'Enviando...',
      formSuccess: 'Información enviada. Nuestro equipo te contactará pronto para la valuación.',
      formError: 'Error al enviar. Por favor intenta nuevamente.',
      whatsappCta: 'Escribir por WhatsApp',
    },
    map: {
      badge: 'ZONA DE COBERTURA',
      title: 'Operamos en',
      titleAccent: 'Chiapas y Región',
      subtitle: 'Presencia estratégica en las principales zonas de plusvalía y crecimiento del estado de Chiapas.',
      mapTitle: 'Mapa de cobertura Grupo Novega Bienes Raíces',
      openMaps: 'Ver en Maps',
      officeTitle: 'NUESTRA OFICINA',
      officeAddress: 'Av. Central Pte. 847 C.7ª Pte. y C.8ª Pte.\nC.P. 29000, Tuxtla Gutiérrez, Chiapas',
      zonesTitle: 'ZONAS CLAVE',
      zones: [
        { name: 'El Jobo', type: 'Residencial' },
        { name: 'Copoya', type: 'Residencial' },
        { name: 'Berriozábal', type: 'Municipal' },
        { name: 'Chiapa de Corzo', type: 'Histórico' },
        { name: 'Tuxtla Gutiérrez', type: 'Comercial' },
      ],
      stats: [
        { value: '20+', label: 'Zonas Cubiertas' },
        { value: '100+', label: 'Propiedades' },
        { value: 'Chiapas', label: 'Cobertura' },
      ],
      cta: 'Consultar Zona Específica',
    },
    marketing: {
      badge: 'PUBLICIDAD Y MARKETING',
      title: 'Visibilidad Para',
      titleAccent: 'Tu Propiedad',
      subtitle: 'Estrategias de marketing inmobiliario diseñadas para maximizar el alcance y acelerar la venta o renta de tu propiedad.',
      services: [
        {
          id: 'fotografia',
          icon: 'Camera',
          title: 'Fotografía y Video Profesional',
          description: 'Sesiones fotográficas y videos de alta calidad que destacan los mejores atributos de tu inmueble.',
        },
        {
          id: 'tour',
          icon: 'Globe',
          title: 'Tour Virtual 360°',
          description: 'Recorridos virtuales inmersivos que permiten a los compradores explorar la propiedad desde cualquier lugar.',
        },
        {
          id: 'redes',
          icon: 'Share2',
          title: 'Redes Sociales',
          description: 'Campañas segmentadas en Facebook, Instagram y TikTok para alcanzar compradores y arrendatarios potenciales.',
        },
        {
          id: 'portales',
          icon: 'Building',
          title: 'Portales Inmobiliarios',
          description: 'Publicación en los principales portales: Lamudi, Inmuebles24, Vivanuncios y MercadoLibre.',
        },
        {
          id: 'ads',
          icon: 'Target',
          title: 'Campañas de Publicidad Digital',
          description: 'Google Ads y Meta Ads dirigidos al perfil exacto del comprador o inquilino ideal para tu propiedad.',
        },
        {
          id: 'crm',
          icon: 'Users',
          title: 'Gestión de Prospectos',
          description: 'Seguimiento profesional de todos los interesados con nuestro CRM especializado en el sector inmobiliario.',
        },
      ],
      cta: 'Solicitar Estrategia de Marketing',
    },
    jobs: {
      badge: 'BOLSA DE TRABAJO',
      title: 'Únete a Nuestro',
      titleAccent: 'Equipo de Élite',
      subtitle: 'Construimos el mejor equipo de profesionales inmobiliarios en Chiapas. ¿Eres parte de esa visión?',
      openings: 'Vacante Disponible',
      positionTitle: 'Agente de Ventas Inmobiliarias',
      positionType: 'Tiempo Completo · Presencial',
      positionLocation: 'Tuxtla Gutiérrez, Chiapas',
      description: 'Buscamos profesionales dinámicos, orientados a resultados y con pasión genuina por el sector inmobiliario. Si tienes habilidades de comunicación sobresalientes y ambición de crecimiento, queremos conocerte.',
      requirementsTitle: 'Requisitos',
      requirements: [
        'Experiencia en ventas (sector inmobiliario deseable)',
        'Excelentes habilidades de comunicación y negociación',
        'Proactividad y orientación al logro de metas',
        'Manejo de redes sociales y herramientas digitales',
        'Licencia de conducir y vehículo propio (deseable)',
      ],
      benefitsTitle: 'Ofrecemos',
      benefits: [
        'Comisiones competitivas + bonos por desempeño',
        'Capacitación y desarrollo profesional continuo',
        'Ambiente de trabajo colaborativo de alto nivel',
        'Flexibilidad y autonomía en tu gestión',
      ],
      applyTitle: '¿Listo para dar el siguiente paso?',
      applySubtitle: 'Completa el formulario y envíanos tu CV. Te contactaremos en menos de 48 horas.',
      formName: 'Nombre completo',
      formEmail: 'Correo electrónico',
      formMessage: 'Cuéntanos por qué te interesa unirte al equipo...',
      formFile: 'Adjuntar CV (PDF)',
      formSubmit: 'Enviar Solicitud',
      formSending: 'Enviando...',
      formSuccess: 'Solicitud enviada. Te contactaremos pronto.',
      applyNote: 'CVs aceptados en formato PDF. Tu información es tratada con total confidencialidad.',
      emailCta: 'Enviar CV por Correo',
    },
    contact: {
      badge: 'CONTÁCTENOS',
      title: 'Estamos Listos',
      titleAccent: 'Para Atenderle',
      subtitle: 'Nuestro equipo de especialistas responde en menos de 24 horas. Cuéntenos sobre su proyecto o propiedad.',
      formName: 'Nombre completo',
      formEmail: 'Correo electrónico',
      formPhone: 'Teléfono (opcional)',
      formMessage: 'Cuéntenos sobre su proyecto o consulta...',
      formSubmit: 'Enviar Mensaje',
      formSending: 'Enviando...',
      formSuccess: 'Mensaje enviado con éxito. Le contactaremos pronto.',
      formError: 'Error al enviar. Por favor intente nuevamente.',
      whatsappCta: 'Escribir por WhatsApp',
      addressLabel: 'DIRECCIÓN',
      address: 'AV. CENTRAL PTE. 847 C.7ª PTE. Y C.8ª PTE.\nCTO. SUR PTE. C.P. 29000\nTuxtla Gutiérrez, Chiapas',
      emailLabel: 'CORREO',
      email: 'novegabienesraices@gmail.com',
      scheduleLabel: 'HORARIO DE ATENCIÓN',
      schedule: 'Lun–Vie: 9:00am – 6:00pm\nSábado: 9:00am – 2:00pm',
      phoneLabel: 'TELÉFONO / WHATSAPP',
      phone: '+52 961 462 5879',
    },
    footer: {
      tagline: 'PATRIMONIO QUE INSPIRA FUTURO',
      description: 'Desarrollo inmobiliario integral con legalidad, transparencia y excelencia en Tuxtla Gutiérrez, Chiapas, México.',
      legal: 'GRUPO NOVEGA BIENES RAICES S.A. DE C.V.',
      rights: '© 2026 Todos los derechos reservados.',
      navTitle: 'NAVEGACIÓN',
      navItems: [
        { label: 'Inicio', href: '#home' },
        { label: 'Nosotros', href: '#about' },
        { label: 'Servicios', href: '#services' },
        { label: 'Propiedades', href: '#properties' },
        { label: 'Bolsa de Trabajo', href: '#jobs' },
        { label: 'Contacto', href: '#contact' },
      ],
      servicesTitle: 'SERVICIOS',
      servicesList: [
        'Intermediación Inmobiliaria',
        'Asesoría Legal y Fiscal',
        'Crédito Hipotecario',
        'Valuación Comercial',
        'Marketing Inmobiliario',
      ],
      socialTitle: 'SÍGUENOS',
      disclaimer: 'Empresa constituida bajo las leyes de los Estados Unidos Mexicanos.',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      properties: 'Properties',
      sell: 'Sell Your House',
      jobs: 'Careers',
      contact: 'Contact',
      langLabel: 'ES',
      cta: 'Contact Us',
    },
    hero: {
      badge: 'Certified Real Estate Firm · Tuxtla Gutiérrez, Chiapas',
      line1: 'LEGACY THAT',
      line2: 'INSPIRES THE FUTURE',
      subtitle: 'We develop, sell, and manage high-value real estate projects with legality, transparency, and absolute efficiency.',
      cta1: 'Schedule Free Consultation',
      cta2: 'Explore Services',
      stat1: { value: '5', label: 'Expert Partners' },
      stat2: { value: '10+', label: 'Years Experience' },
      stat3: { value: '100%', label: 'Legal Backing' },
    },
    about: {
      badge: 'OUR STORY',
      title: 'Expert Backing.',
      titleAccent: 'Real Results.',
      body: 'GRUPO NOVEGA BIENES RAICES was born from the shared vision of five partners with combined experience in the real estate sector of Chiapas. We are an innovative company, backed by a team of tax attorneys and specialists in the real estate sector, committed to legality and excellence in every transaction.',
      missionLabel: 'OUR MISSION',
      mission: 'To provide comprehensive solutions through the development, commercialization, and management of residential and commercial projects, with legality, transparency, and efficiency, to protect and maximize the assets of our clients.',
      legalBacking: 'Backed by a team of tax attorneys specialized in the real estate sector',
      values: [
        'Integrity & Transparency',
        'Professionalism',
        'Legal Responsibility',
        'Client Focus',
        'Continuous Innovation',
        'Sustainable Development',
      ],
    },
    trayectoria: {
      badge: 'PROFESSIONAL TRACK RECORD',
      title: 'Certified',
      titleAccent: 'Advisors',
      subtitle: 'Our team holds accreditations and recognitions that guarantee the highest quality in every real estate advisory.',
      advisors: [
        {
          name: 'Senior Real Estate Advisor',
          role: 'Real Estate Specialist',
          certs: ['AMPI Certified', 'Certified Appraiser', 'Mortgage Credit'],
        },
        {
          name: 'Tax Attorney',
          role: 'Real Estate Legal Advisor',
          certs: ['Professional License', 'Tax Law', 'Real Estate Law'],
        },
        {
          name: 'Development Manager',
          role: 'Project Specialist',
          certs: ['PMI Certified', 'Market Analysis', 'Commercial Valuation'],
        },
        {
          name: 'Commercial Agent',
          role: 'Comprehensive Commercialization',
          certs: ['Advanced Negotiation', 'Real Estate Marketing', 'Specialized CRM'],
        },
      ],
      cta: 'Meet Our Team',
      uploadCta: 'Are you a certified advisor? Join the team',
    },
    services: {
      badge: 'OUR SERVICES',
      title: 'Protect Your',
      titleAccent: 'Assets',
      subtitle: 'Entrust us with the comprehensive commercialization of your property. We handle everything: valuation, marketing, negotiation, and legal closing.',
      priceHeader: 'Reference Pricing',
      businessModel: 'You contact us — we handle the complete commercialization of your property.',
      items: [
        {
          id: 'intermediacion',
          icon: 'Home',
          label: 'BROKERAGE',
          title: 'Real Estate Brokerage',
          description: 'Entrust your property to us and our team manages all commercialization: valuation, advertising, buyer attention, and legal closing with full legal backing.',
          pricing: [
            { name: 'Sales management', price: '5%–7% commission', note: 'on sale value' },
            { name: 'Purchase management', price: '3%–5% commission', note: 'on purchase value' },
            { name: 'Rental management', price: '1 month rent', note: 'per successful placement' },
          ],
          cta: 'Request Management',
        },
        {
          id: 'asesoria',
          icon: 'FileText',
          label: 'ADVISORY',
          title: 'Specialized Advisory',
          description: 'We have specialists in real estate law, taxation, and mortgage credit management to maximize your investments and reduce risks.',
          pricing: [
            { name: 'Real estate legal advisory', price: 'From $1,500 MXN', note: 'per consultation' },
            { name: 'Real estate tax advisory', price: 'From $2,000 MXN', note: 'per consultation' },
            { name: 'Mortgage credit management', price: 'Free / $3,000 MXN', note: 'per management' },
          ],
          cta: 'Schedule Consultation',
        },
        {
          id: 'gestion',
          icon: 'TrendingUp',
          label: 'ASSET MANAGEMENT',
          title: 'Asset Management',
          description: 'We analyze, evaluate, and enhance your real estate assets with precise market studies, commercial valuations, and effective marketing strategies.',
          pricing: [
            { name: 'Property evaluation & analysis', price: 'From $2,500 MXN', note: '' },
            { name: 'Commercial market valuation', price: 'From $3,500 MXN', note: '' },
            { name: 'Real estate marketing', price: 'From $2,000 MXN', note: 'per campaign' },
          ],
          cta: 'Request Valuation',
        },
      ],
    },
    properties: {
      badge: 'FEATURED PROPERTIES',
      title: 'Sales &',
      titleAccent: 'Rentals',
      subtitle: 'A selection of premium properties in Tuxtla Gutiérrez and high-value areas of Chiapas.',
      contactCta: 'Request Information',
      detailsCta: 'View Details',
      viewAll: 'View All Properties',
      beds: 'Beds',
      baths: 'Baths',
      sqm: 'sqm',
      filterAll: 'All',
      filterVenta: 'Sales',
      filterRenta: 'Rentals',
      items: [
        {
          id: 1,
          category: 'venta',
          type: 'Residential',
          title: 'Premium Residential Home',
          location: 'Fracc. Terán, Tuxtla Gutiérrez',
          price: '$4,500,000',
          currency: 'MXN',
          beds: 4,
          baths: 3,
          sqm: 320,
          badge: 'FEATURED',
          image: 'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
          id: 2,
          category: 'renta',
          type: 'Apartment',
          title: 'Executive Apartment',
          location: 'Downtown, Tuxtla Gutiérrez',
          price: '$12,000',
          currency: 'MXN/month',
          beds: 2,
          baths: 2,
          sqm: 95,
          badge: 'FOR RENT',
          image: 'https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
          id: 3,
          category: 'venta',
          type: 'Commercial',
          title: 'Strategic Commercial Space',
          location: 'Blvd. Belisario Domínguez',
          price: '$850,000',
          currency: 'MXN',
          beds: null,
          baths: null,
          sqm: 120,
          badge: 'FOR SALE',
          image: 'https://images.pexels.com/photos/260931/pexels-photo-260931.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
      ],
    },
    desarrollos: {
      badge: 'DEVELOPMENT PROJECTS',
      title: 'Real Estate',
      titleAccent: 'Developments',
      subtitle: 'Residential and commercial development projects with the highest quality standards in Chiapas.',
      statusLabel: 'Status',
      detailsCta: 'View Details',
      items: [
        {
          id: 1,
          title: 'Residencial Las Cumbres',
          location: 'Berriozábal, Chiapas',
          status: 'PRE-SALE',
          statusColor: 'gold',
          description: 'Residential complex of 40 units with top-tier amenities, green areas, and 24/7 security.',
          units: '40 Units',
          delivery: 'Q4 2026',
          type: 'Residential',
          image: 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
          id: 2,
          title: 'Plaza Comercial El Jobo',
          location: 'El Jobo, Tuxtla Gutiérrez',
          status: 'UNDER CONSTRUCTION',
          statusColor: 'blue',
          description: 'Commercial development with 15 strategically located spaces in one of the fastest-growing zones.',
          units: '15 Spaces',
          delivery: 'Q2 2027',
          type: 'Commercial',
          image: 'https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
          id: 3,
          title: 'Villas Copoya',
          location: 'Copoya, Chiapas',
          status: 'COMING SOON',
          statusColor: 'muted',
          description: 'Exclusive horizontal subdivision with 25 luxury villas in the heart of Copoya.',
          units: '25 Villas',
          delivery: '2027',
          type: 'Premium Residential',
          image: 'https://images.pexels.com/photos/259588/pexels-photo-259588.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
      ],
      cta: 'Request Development Information',
    },
    vende: {
      badge: 'SELL YOUR PROPERTY',
      title: 'Want to Sell',
      titleAccent: 'Your House?',
      subtitle: 'Tell us about your property and our team will contact you with a free valuation and selling strategy.',
      formName: 'Full name',
      formEmail: 'Email address',
      formPhone: 'Phone',
      formAddress: 'Property location',
      formType: 'Property type',
      formTypeOptions: ['House', 'Apartment', 'Land', 'Commercial Space', 'Other'],
      formMessage: 'Tell us more about your property (size, condition, reason for selling)...',
      formSubmit: 'Send Information',
      formSending: 'Sending...',
      formSuccess: 'Information sent. Our team will contact you soon for the valuation.',
      formError: 'Error sending. Please try again.',
      whatsappCta: 'Message via WhatsApp',
    },
    map: {
      badge: 'COVERAGE ZONE',
      title: 'We Operate Throughout',
      titleAccent: 'Chiapas & Region',
      subtitle: 'Strategic presence in the main high-value and high-growth areas of the state of Chiapas.',
      mapTitle: 'Grupo Novega Bienes Raíces coverage map',
      openMaps: 'View on Maps',
      officeTitle: 'OUR OFFICE',
      officeAddress: 'Av. Central Pte. 847 C.7th & C.8th\nZip 29000, Tuxtla Gutiérrez, Chiapas',
      zonesTitle: 'KEY ZONES',
      zones: [
        { name: 'El Jobo', type: 'Residential' },
        { name: 'Copoya', type: 'Residential' },
        { name: 'Berriozábal', type: 'Municipal' },
        { name: 'Chiapa de Corzo', type: 'Historic' },
        { name: 'Tuxtla Gutiérrez', type: 'Commercial' },
      ],
      stats: [
        { value: '20+', label: 'Zones Covered' },
        { value: '100+', label: 'Properties' },
        { value: 'Chiapas', label: 'Coverage' },
      ],
      cta: 'Inquire About Specific Zone',
    },
    marketing: {
      badge: 'ADVERTISING & MARKETING',
      title: 'Visibility For',
      titleAccent: 'Your Property',
      subtitle: 'Real estate marketing strategies designed to maximize reach and accelerate the sale or rental of your property.',
      services: [
        {
          id: 'fotografia',
          icon: 'Camera',
          title: 'Professional Photography & Video',
          description: 'High-quality photo sessions and videos that highlight the best attributes of your property.',
        },
        {
          id: 'tour',
          icon: 'Globe',
          title: '360° Virtual Tour',
          description: 'Immersive virtual tours that allow buyers to explore the property from anywhere in the world.',
        },
        {
          id: 'redes',
          icon: 'Share2',
          title: 'Social Media',
          description: 'Targeted campaigns on Facebook, Instagram, and TikTok to reach potential buyers and tenants.',
        },
        {
          id: 'portales',
          icon: 'Building',
          title: 'Real Estate Portals',
          description: 'Publication on leading portals: Lamudi, Inmuebles24, Vivanuncios, and MercadoLibre.',
        },
        {
          id: 'ads',
          icon: 'Target',
          title: 'Digital Advertising Campaigns',
          description: 'Google Ads and Meta Ads targeting the exact buyer or tenant profile for your property.',
        },
        {
          id: 'crm',
          icon: 'Users',
          title: 'Prospect Management',
          description: 'Professional follow-up of all interested parties with our CRM specialized in real estate.',
        },
      ],
      cta: 'Request Marketing Strategy',
    },
    jobs: {
      badge: 'CAREERS',
      title: 'Join Our',
      titleAccent: 'Elite Team',
      subtitle: 'We are building the best real estate team in Chiapas. Are you part of that vision?',
      openings: 'Open Position',
      positionTitle: 'Real Estate Sales Agent',
      positionType: 'Full-Time · On-Site',
      positionLocation: 'Tuxtla Gutiérrez, Chiapas',
      description: 'We are looking for dynamic, results-oriented professionals with a genuine passion for real estate. If you have outstanding communication skills and ambition for growth, we want to meet you.',
      requirementsTitle: 'Requirements',
      requirements: [
        'Sales experience (real estate sector desirable)',
        'Excellent communication and negotiation skills',
        'Proactivity and goal achievement orientation',
        'Social media management and digital tools',
        "Driver's license and own vehicle (desirable)",
      ],
      benefitsTitle: 'We Offer',
      benefits: [
        'Competitive commissions + performance bonuses',
        'Continuous training and professional development',
        'Collaborative, high-level work environment',
        'Flexibility and autonomy in your management',
      ],
      applyTitle: 'Ready to take the next step?',
      applySubtitle: 'Complete the form and send us your CV. We will contact you within 48 hours.',
      formName: 'Full name',
      formEmail: 'Email address',
      formMessage: 'Tell us why you are interested in joining the team...',
      formFile: 'Attach CV (PDF)',
      formSubmit: 'Submit Application',
      formSending: 'Sending...',
      formSuccess: 'Application sent. We will contact you soon.',
      applyNote: 'CVs accepted in PDF format. Your information is handled with full confidentiality.',
      emailCta: 'Send CV via Email',
    },
    contact: {
      badge: 'CONTACT US',
      title: 'We Are Ready',
      titleAccent: 'To Assist You',
      subtitle: 'Our team of specialists responds in less than 24 hours. Tell us about your project or property.',
      formName: 'Full name',
      formEmail: 'Email address',
      formPhone: 'Phone (optional)',
      formMessage: 'Tell us about your project or inquiry...',
      formSubmit: 'Send Message',
      formSending: 'Sending...',
      formSuccess: 'Message sent successfully. We will contact you soon.',
      formError: 'Error sending. Please try again.',
      whatsappCta: 'Message via WhatsApp',
      addressLabel: 'ADDRESS',
      address: 'AV. CENTRAL PTE. 847 C.7th & C.8th\nCTO. SUR PTE. ZIP 29000\nTuxtla Gutiérrez, Chiapas, Mexico',
      emailLabel: 'EMAIL',
      email: 'novegabienesraices@gmail.com',
      scheduleLabel: 'BUSINESS HOURS',
      schedule: 'Mon–Fri: 9:00am – 6:00pm\nSaturday: 9:00am – 2:00pm',
      phoneLabel: 'PHONE / WHATSAPP',
      phone: '+52 961 462 5879',
    },
    footer: {
      tagline: 'LEGACY THAT INSPIRES THE FUTURE',
      description: 'Comprehensive real estate development with legality, transparency, and excellence in Tuxtla Gutiérrez, Chiapas, Mexico.',
      legal: 'GRUPO NOVEGA BIENES RAICES S.A. DE C.V.',
      rights: '© 2026 All rights reserved.',
      navTitle: 'NAVIGATION',
      navItems: [
        { label: 'Home', href: '#home' },
        { label: 'About', href: '#about' },
        { label: 'Services', href: '#services' },
        { label: 'Properties', href: '#properties' },
        { label: 'Careers', href: '#jobs' },
        { label: 'Contact', href: '#contact' },
      ],
      servicesTitle: 'SERVICES',
      servicesList: [
        'Real Estate Brokerage',
        'Legal & Tax Advisory',
        'Mortgage Credit Management',
        'Commercial Valuation',
        'Real Estate Marketing',
      ],
      socialTitle: 'FOLLOW US',
      disclaimer: 'Company incorporated under the laws of Mexico.',
    },
  },
};
